import { isDeliverToFulfillmentCenter } from 'swag-common/utils/order/is-deliver-to-fulfillment-center.util';
import getReceivingFeeForItemsList from './get-receiving-fee-for-items-list.logic';
function getOrderReceivingFee(order) {
  return !isDeliverToFulfillmentCenter(order) ? 0 : getReceivingFeeForItemsList(order.items);
}
export default getOrderReceivingFee;